import { render, staticRenderFns } from "./CreateAdminForm.vue?vue&type=template&id=9b9659f4&"
import script from "./CreateAdminForm.vue?vue&type=script&lang=js&"
export * from "./CreateAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports